module.exports = __webpack_public_path__ + "img/title_star.c3486430.png";